import { TextMobile as Text } from '@alfa-bank/site-text-v2/mobile';
// Адаптер будет задепрекейчен в ALFABANKRU-86356
// eslint-disable-next-line
import { TagMobile as CoreTag } from '@alfalab/core-components-tag/mobile';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { IDeps, TTag } from '../models';
import { Tag as Component } from '../tag';
import styles from '../styles/index.css';

// className прокидывается через переменную tagClassNames
// eslint-disable-next-line styler/check-styler
export const TagMobile = createWidget<IDeps, TTag>(
    {
        CoreTag,
        styles,
        Text,
    },
    { priorityStyler: true }
)(Component);
